import { ContractContentTypeEnum } from '@/api/rights/types';
import { contractsUrl } from '@/constant';

/** 获取分期商城协议链接 */
export const getNoramlContractIframeUrl = (
  url: string,
  contentType?: ContractContentTypeEnum,
): string => {
  if (contentType === ContractContentTypeEnum.PDF) {
    return `${contractsUrl || ''}?pdf_url=${url}`;
  }
  return url;
};
